import { BIZ, HOME_FEATURES, TESTIMONIALS, APP_URL, PLAYSTORE_URL } from "../data/content";
import PricingGrid from "../components/PricingGrid";
import CtaBanner from "../components/CtaBanner";
import AppScreenshots from "../components/AppScreenshots";

export default function HomePage({ nav }) {
  return (
    <div className="page">

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-mesh" />
        <div className="hero-dots" />
        <div className="hero-inner">

          {/* Left: copy */}
          <div>
            <div className="hero-pill"><span />Restaurant POS &amp; Billing Software</div>
            <h1>Smart billing for<br />every <em>restaurant</em></h1>
            <p className="hero-desc">
              Cloud-based POS software with KOT, GST billing, inventory, kitchen display,
              loyalty programmes, and 20+ features — all in one app for Indian food businesses.
            </p>
            <div className="hero-btns">
              <a href={APP_URL} target="_blank" rel="noopener noreferrer" className="btn-lime">
                Start Free Trial →
              </a>
              <button className="btn-outline-w" onClick={() => nav("features")}>
                Explore Features
              </button>
            </div>
            <div className="hero-numbers">
              {[["500+", "Restaurants"], ["20+", "Features"], ["₹0", "Free 15 Days"], ["₹399", "Starts From"]].map(([v, l], i) => (
                <div key={i}>
                  <div className="hn-val">{v}</div>
                  <div className="hn-lbl">{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: dashboard mockup */}
          <div className="dash-wrap">
            <div className="dash" style={{ position: "relative" }}>
              <div className="dash-tag dt1">🧾 GST compliant billing</div>
              <div className="dash-tag dt2">☁️ Always cloud synced</div>
              <div className="dh">
                <div className="dh-title">Today's Overview</div>
                <div className="dh-live"><span />Live</div>
              </div>
              <div className="d-kpis">
                {[["₹18,420", "Revenue"], ["47", "Orders"], ["12", "Tables"], ["3", "KOTs Active"]].map(([v, l], i) => (
                  <div className="dkpi" key={i}>
                    <div className="dkpi-v">{v}</div>
                    <div className="dkpi-l">{l}</div>
                  </div>
                ))}
              </div>
              <div className="d-lbl">Recent Orders</div>
              {[
                ["Table 4 — Butter Chicken", "₹480", "Served",  "s"],
                ["Table 7 — Thali Set x2",   "₹760", "Cooking", "c"],
                ["Takeaway — Biryani",        "₹320", "Ready",   "r"],
              ].map(([name, amt, status, cls], i) => (
                <div className="d-order" key={i}>
                  <div className="d-oname">{name}</div>
                  <div className="d-ometa">
                    <div className="d-oamt">{amt}</div>
                    <div className={`d-os os-${cls}`}>{status}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* ── WHY OOON ── */}
      <section className="section">
        <div className="eyebrow">Why Ooon</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 18 }}>
          <div>
            <h2 className="sec-title">Built for Indian<br />restaurants, <em>by design</em></h2>
            <p className="sec-sub">No Windows configuration. No technical expertise. Works on any Android phone. Start billing in minutes.</p>
          </div>
        </div>
        <div className="why-grid">
          {[
            { icon: "☁️",  title: "Cloud-Based & Synced",   desc: "Your data is always backed up and accessible from any device at any time. No local storage limitations." },
            { icon: "🇮🇳", title: "GST Ready",              desc: "Automatically handles CGST, SGST, IGST, and UTGST. Zero manual tax calculation needed." },
            { icon: "📱",  title: "Any Android Device",     desc: "No expensive hardware needed. Runs on any Android phone or tablet you already own." },
            { icon: "⚡",  title: "Setup in Minutes",       desc: "No Windows configuration, no IT support. Install and start billing within minutes." },
            { icon: "🔐",  title: "Role-Based Access",      desc: "Control what each staff member can see and do with secure, customisable permissions." },
            { icon: "🎁",  title: "Built-in Loyalty",       desc: "Reward repeat customers with redeemable points. Track redemptions automatically from the app." },
          ].map((w, i) => (
            <div className="wc" key={i}>
              <div className="wc-icon">{w.icon}</div>
              <h3>{w.title}</h3>
              <p>{w.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── FEATURES PREVIEW ── */}
      <section className="section" style={{ paddingTop: 0 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 18, marginBottom: 40 }}>
          <div>
            <div className="eyebrow">Key Features</div>
            <h2 className="sec-title">What Ooon does <em>for you</em></h2>
            <p className="sec-sub">A glimpse of the most-used features by restaurant owners every day.</p>
          </div>
          <button
            onClick={() => nav("features")}
            style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "var(--g1)", color: "var(--lime2)", padding: "12px 24px", borderRadius: 12, fontWeight: 700, fontSize: "0.9rem", fontFamily: "'Outfit',sans-serif", cursor: "pointer", border: "none", boxShadow: "0 4px 16px rgba(10,61,46,.18)", transition: "all .2s", flexShrink: 0 }}
          >
            Explore All 20+ Features →
          </button>
        </div>
        <div className="why-grid">
          {HOME_FEATURES.map((f, i) => (
            <div className="wc" key={i}>
              <div className="wc-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 36 }}>
          <button
            onClick={() => nav("features")}
            style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "transparent", color: "var(--g2)", padding: "12px 28px", borderRadius: 12, fontWeight: 700, fontSize: "0.95rem", fontFamily: "'Outfit',sans-serif", cursor: "pointer", border: "2px solid var(--border)", transition: "all .2s" }}
          >
            View All Features &amp; Pricing →
          </button>
        </div>
      </section>

      {/* ── APP SCREENSHOTS ── */}
      <AppScreenshots />

      {/* ── BUSINESS TYPES ── */}
      <div className="biz-band">
        <div className="eyebrow">Works for everyone</div>
        <h2 className="sec-title" style={{ fontSize: "1.7rem" }}>Designed for <em>every</em> food business</h2>
        <div className="biz-row">
          {BIZ.map((b, i) => <div className="biz-chip" key={i}>{b.icon} {b.label}</div>)}
        </div>
      </div>

      {/* ── PRICING ── */}
      <div className="price-band">
        <div style={{ position: "relative", zIndex: 2, textAlign: "center", maxWidth: 500, margin: "0 auto" }}>
          <div className="eyebrow">Pricing</div>
          <h2 className="sec-title">Simple, <em style={{ color: "var(--lime2)" }}>honest</em> pricing</h2>
          <p className="sec-sub" style={{ margin: "0 auto" }}>Start free for 15 days. No credit card. Scale when you're ready.</p>
        </div>
        <PricingGrid />
        <div style={{ textAlign: "center", marginTop: 36, position: "relative", zIndex: 2 }}>
          <button
            onClick={() => nav("features")}
            style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,.1)", color: "rgba(255,255,255,.7)", padding: "12px 28px", borderRadius: 12, fontWeight: 600, fontSize: "0.9rem", fontFamily: "'Outfit',sans-serif", cursor: "pointer", border: "1px solid rgba(255,255,255,.2)", transition: "all .2s" }}
          >
            See Full Feature Comparison →
          </button>
        </div>
      </div>

      {/* ── TESTIMONIALS ── */}
      <section className="testi-sec">
        <div style={{ textAlign: "center", maxWidth: 500, margin: "0 auto" }}>
          <div className="eyebrow">Customer Stories</div>
          <h2 className="sec-title">Trusted by restaurant<br />owners <em>across India</em></h2>
        </div>
        <div className="testi-grid">
          {TESTIMONIALS.map((t, i) => (
            <div className="tc" key={i}>
              <div className="tc-stars">★★★★★</div>
              <p className="tc-quote">"{t.text}"</p>
              <div className="tc-bottom">
                <div className="tc-av">{t.init}</div>
                <div>
                  <div className="tc-name">{t.name}</div>
                  <div className="tc-role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── DOWNLOAD ── */}
      <div className="dl-band">
        <div className="dl-t">
          <h2>Available on Android</h2>
          <p>Download from Google Play or use the web app on any browser.</p>
        </div>
        <div className="dl-btns">
          <a href={PLAYSTORE_URL} target="_blank" rel="noopener noreferrer" className="dl-play">▶ Google Play Store</a>
          <a href={APP_URL}       target="_blank" rel="noopener noreferrer" className="dl-web">🌐 Open Web App</a>
        </div>
      </div>

      <div style={{ height: 80 }} />
      <CtaBanner
        title="Ready to grow your restaurant?"
        subtitle="Start your 15-day free trial. No credit card. No commitment."
        btnText="Get Started Free →"
      />
    </div>
  );
}
